import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Product } from '@mwe/models';
import { TranslateDirective } from '@ngx-translate/core';
import { WizardProductCardContainerComponent } from './wizard-product-card-container.component';

@Component({
  selector: 'mwe-wizard-product-card-list',
  templateUrl: './wizard-product-card-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateDirective, WizardProductCardContainerComponent],
})
export class WizardProductCardListComponent {
  listHeaderKey = input<string>();
  productList = input.required<Product[]>();
  isAvailableAtNewAddress = input<boolean>(false);
}
